import React from 'react';
import {Outlet} from 'react-router';
import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import {grey} from '@mui/material/colors';

import useBreakpoint from '../hooks/useBreakpoint';
import {useIsAuthenticated} from '../hooks/useIsAuthenticated';
import {LinkBehavior} from './LinkBehavior';
import FirmaDOXLogo from '../assets/img/dox-logo.png';

const Header = () => {
  const breakpoint = useBreakpoint();
  const isAuthenticated = useIsAuthenticated();

  return (
    <AppBar position="sticky" color={'inherit'} enableColorOnDark>
      <Toolbar component={Container} sx={{}}>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            minHeight: 80,
          }}>
          <Button
            component={LinkBehavior}
            to={'/'}
            color="inherit"
            sx={{paddingLeft: 0, paddingRight: 0}}>
            <img src={FirmaDOXLogo} alt="Logo" />
          </Button>

          {process.env.NODE_ENV === `development` && (
            <Tooltip title="Responsive Design">
              <Typography>
                <small>{JSON.stringify({breakpoint, isAuthenticated})}</small>
              </Typography>
            </Tooltip>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#212121',
        display: 'flex',
        alignItems: 'center',
        minHeight: 80,
      }}>
      <Container>
        <Grid container paddingY={2} justifyContent={'space-between'}>
          <Grid item xs={2}>
            <Typography
              color="white"
              variant="h6"
              component="div"
              sx={{}}
              align={'left'}>
              FirmaDOX
            </Typography>
          </Grid>

          <Grid item xs={7}>
            <Typography color="white" variant="h6" component="div" sx={{}}>
              Copyright &copy; {new Date().getFullYear()}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const BaseContainer = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}>
      <Header />

      <Box
        sx={{
          flex: 1,
          backgroundColor: grey[200],
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Box
          // disableGutters={true}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            // paddingTop: 3,
            // paddingBottom: 3,
          }}>
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default BaseContainer;
